module.exports = __webpack_public_path__ + "static/img/solution1.773c2e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solution1.jpg
// module id = tL20
// module chunks = 9